<div class="{{localService.selectedLanguageCode}} working_as" *ngIf="items" id="working_as" [ngStyle]="{'max-width' : 'calc(100% - '+ headerWidth +'px'}" (window:resize)="onFreshFormat()">
  <div *ngIf="!isShowCompressed">
    <span *ngIf="localService.selectedPageName" class="en">&nbsp;/&nbsp;</span>
    <span *ngIf="localService.selectedPageName">{{localService.selectedPageName.key}}</span>
    <span *ngIf="localService.selectedPageName" class="en">&nbsp;/&nbsp;</span>
    <span *ngIf="localService.selectedPageName">{{localService.selectedPageName.value}}</span>
    <span *ngFor="let item of items" [ngClass]="localService.getLanguageCode(item.key)">
      <span class="en" *ngIf="!item.isSelected">&nbsp;/&nbsp;</span>
      <span class="en" *ngIf="item.isSelected">&nbsp;(</span>{{item.value}}<span class="en" *ngIf="item.isSelected">)&nbsp;</span>
    </span>
    <span class="en" *ngIf="localService.tokenNumber != ''">&nbsp;/&nbsp;{{localService.tokenNumber}}</span>
  </div>
  <div *ngIf="isShowCompressed">
    <span class="en button" (click)="onShowHideMore()">/...</span>
    <span *ngIf="localService.selectedPageName && compressedItems.length == 0 && localService.tokenNumber == ''">
      <span class="en">&nbsp;/&nbsp;</span>
      {{localService.selectedPageName.value}}
    </span>
    <span *ngFor="let item of compressedItems" [ngClass]="localService.getLanguageCode(item.key)">
      <span class="en" *ngIf="!item.isSelected">&nbsp;/&nbsp;</span>
      <span class="en" *ngIf="item.isSelected">&nbsp;(</span>{{item.value}}<span class="en" *ngIf="item.isSelected">)&nbsp;</span>
    </span>
    <span class="en" *ngIf="localService.tokenNumber != ''">&nbsp;/&nbsp;{{localService.tokenNumber}}</span>
  </div>
</div>
<div class="banner working_as_root" *ngIf="items && isShowRoot">
  <i class="material-icons" style="transform: rotate(45deg);color: palevioletred;font-size: 25px;float:right;" (click)="onShowHideMore()" title="{{localService.languageContent.common.close}}">add_circle_outline</i>
  <div *ngIf="localService.selectedPageName"><span class="en">&nbsp;/&nbsp;</span>{{localService.selectedPageName.key}}</div>
  <div *ngIf="localService.selectedPageName"><span class="en">&nbsp;/&nbsp;</span>{{localService.selectedPageName.value}}</div>
  <span *ngFor="let item of items" [ngClass]="localService.getLanguageCode(item.key)">
    <span class="en" *ngIf="!item.isSelected">&nbsp;/&nbsp;</span>
    <span class="en" *ngIf="item.isSelected">&nbsp;(</span>{{item.value}}<span class="en" *ngIf="item.isSelected">)&nbsp;</span>
  </span>
  <div class="en" *ngIf="localService.tokenNumber != ''">&nbsp;/&nbsp;{{localService.tokenNumber}}</div>
</div>
